<template>
	<div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 阳光配餐报表</el-breadcrumb-item>
				<el-breadcrumb-item>消费结算表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<div class="handle-box left">
				<el-checkbox-group v-model="data.holiday" size="mini" class="left mr10">
					<el-checkbox-button :label="0">平日</el-checkbox-button>
					<el-checkbox-button :label="1">节假日</el-checkbox-button>
				</el-checkbox-group>
				<el-date-picker type="daterange" v-model="data.date" value-format="yyyy-MM-dd" size="large"
					class="left mr10">
				</el-date-picker>
				<el-button type="primary" icon="el-icon-search" @click="search" v-if="power.search">搜索</el-button>
			</div>
			<div class="handle-box right">
				<el-button type="primary" @click="toExport" v-if="power.export">
					<i class="if-lcon-daoru"></i>导出
				</el-button>
				<el-button type="primary" @click="toPrint" class="mr10" v-if="power.print">
					<i class="if-lcon-dayin"></i>打印
				</el-button>
			</div>
			<el-table id="balanceBooksRecordTable" ref="table" :data="data.rows" border class="table"
				@selection-change="handleSelectionChange" :span-method="tableSpanMethod">
				<el-table-column align="left" prop="typeName" label="消费类别" width="300">
				</el-table-column>
				<el-table-column align="center" prop="name" label="餐段" width="200">
				</el-table-column>
				<el-table-column align="center" prop="count" label="次数" width="100">
				</el-table-column>
				<el-table-column align="right" prop="amount1" label="交易额" width="200">
				</el-table-column>
				<el-table-column align="right" prop="amount2" label="结算额" width="200">
				</el-table-column>
				<el-table-column align="center" prop="remark" label="备注" width="200">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import printJS from 'print-js';
	export default {
		name: 'yhpremealreport',
		data() {
			return {
				data: {
					holiday: [],
					date: []
				},
				visible: {
					print: false,
					loading: false
				},
				power: {
					pageId: 92,
					search: false,
					export: false,
					print: false
				}
			}
		},
		methods: {
			search(change) {
				let ths = this;
				ths.visible.loading = true;
				let where = '';
				for (let i = 0; i < ths.data.holiday.length; i++) {
					where += ('&holiday=' + ths.data.holiday[i]);
				}
				window.ax.get('api/report/yhpos/balancebooksrecordlist?datebegin=' + ths.data.date[0] + '&dateend=' + ths
					.data.date[1] + where + '&sign=' + window.$gloable.userinfo.sign, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.rows = data.data;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.search(true);
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			handleSelectionChange(selections) {
				this.data.selections = selections;
			},
			toExport() {
				let ths = this;
				let where = '';
				for (let i = 0; i < ths.data.holiday.length; i++) {
					where += ('&holiday=' + ths.data.holiday[i]);
				}
				window.open('api/report/yhpos/ExportBalanceBooksRecordList?datebegin=' + ths.data.date[0] + '&dateend=' + ths
					.data.date[1] + where + '&sign=' + window.$gloable.userinfo.sign, '_blank');
			},
			tableSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex == 0) {
					if (row.typeName.indexOf('| ') == 0) {
						//row.typeName = row.typeName.substring(1);
						return [1, 6];
					}
				}
				//return [0, 0];
			},
			toPrint() {
				let ths = this;
				let html = document.querySelector('#balanceBooksRecordTable').innerHTML;
				// 新建一个 DOM
				const div = document.createElement('div');
				const printDOMID = 'printDOMElement';
				div.id = printDOMID
				div.innerHTML = html;

				// 提取第一个表格的内容 即表头
				const th = div.querySelectorAll('.el-table__header-wrapper th');
				const ThsTextArry = [];
				for (let i = 0, len = th.length; i < len; i++) {
					if (th[i].innerText !== '') ThsTextArry.push(th[i].innerText);
				}

				// 删除多余的表头
				div.querySelector('.hidden-columns').remove();
				// 第一个表格的内容提取出来后已经没用了 删掉
				div.querySelector('.el-table__header-wrapper').remove();

				// 将第一个表格的内容插入到第二个表格
				let newHTML = '<tr>';
				for (let i = 0, len = ThsTextArry.length; i < len; i++) {
					let align = '';
					if (i == 0) {
						align = 'left';
					} else if (i == 1 || i == 2 || i == 5) {
						align = 'center';
					} else if (i == 3 || i == 4) {
						align = 'right';
					}
					newHTML += '<td style="text-align:' + align + ';font-weight:bold;font-size:18px !important;">' + ThsTextArry[i] + '</td>';
				}

				newHTML += '</tr>';
				div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('afterbegin', newHTML);
				// 将新的 DIV 添加到页面 打印后再删掉
				div.querySelector('table').border = 1;

				//let header = document.createElement('div');
				//header.innerHTML 
				let headerHtml =
					'<div style="font-weight:900;text-align:center;font-size:20px !important;">员工食堂'+new Date(ths.data.date[0]).toDateFormatString('yyyy年MM月')+'消费结算表</div><div style="width:60%;float:left;font-size:18px !important;">结算日期：' +
					ths.data.date[0] + ' 至 ' + ths.data.date[1] + '</div><div style="width:40%;float:left;font-size:18px !important;">打印时间：' +
					new Date().toDateFormatString('yyyy-MM-dd hh:mm:ss') + '</div>';
				//header.style.fontWeight = '900';
				//header.style.textAlign = 'center';
				//header.innerText = '';

				let tbody = div.querySelectorAll('table tbody')[1];
				let trs = tbody.querySelectorAll('tr');
				let idx = 0;
				let page = 0;
				let size = 39;
				let total = Math.ceil(trs.length / size);
				html = '';
				while (page < total) {
					let h = 1430;
					if (page == total - 1) {
						h = 1380;
					}
					html += '<div style="height:' + h + 'px;background:#cccccc;">';
					html += headerHtml;
					let tableBeginHtml =
						'<table style="width:1000px;clear:both;" cellspacing="0" cellpadding="0" border="1"><colgroup><col width="200"><col width="180"><col width="100"><col width="150"><col width="150"><col width="220"></colgroup><tbody>';
					html += tableBeginHtml;
					html += newHTML;
					for (let i = size * page; i < trs.length; i++) {
						++idx;
						let tr = trs[i];
						html += '<tr>';
						let tds = tr.querySelectorAll('td');
						let c = 0;
						for (let j = 0; j < tds.length; j++) {
							let align = '';
							if (j == 0) {
								align = 'left';
							} else if (j == 1 || j == 2 || j == 5) {
								align = 'center';
							} else if (j == 3 || j == 4) {
								align = 'right';
							}
							let td = tds[j];
							let txt = td.innerText;
							let colspan = 1;
							if (txt.indexOf('小计') > -1 || txt.indexOf('合计') > -1) {
								colspan = 2;
								++j;
							} else {
								colspan = td.colSpan;
							}
							c += colspan;
							if (c <= 6) {
								html += '<td colspan="' + colspan + '" style="text-align:' + align + ';font-size:18px !important;">' + txt + '</td>';
							}
						}
						html += '</tr>';
						if (idx % size == 0) {
							++page;
							html += '</tbody></table>';
							break;
						} else if (i == trs.length - 1) {
							++page;
							html += '</tbody></table>';
							break;
						}
					}
					if (total == page) {
						html += '</div><div style="clear:both;height:100px;line-height:50px;"><div style="float:left;width:30%;font-size:18px !important;">办公室主任：</div><div style="float:left;width:30%;font-size:18px !important;">主管主任：</div><div style="float:left;width:15%;font-size:18px !important;">食堂：</div><div style="float:left;width:15%;font-size:18px !important;">管理员：</div><div style="float:left;width:10%;font-size:18px !important;text-align:right;">页码：' + page + '&nbsp;</div></div>';
					} else {
						html += '</div><div style="clear:both;page-break-after:always;height:50px;line-height:50px;text-align:right;font-size:18px !important;">页码：' + page + '&nbsp;</div>';
					}
				}
				div.innerHTML = html;
				div.style.width = "1020px";

				//div.style.fontSize = "20px";
				
				//div.style.position = "absolute";
				//div.style.left = "0px";
				//div.style.top = "0px";
				//div.style.padding = "2px";
				//div.style.backgroundColor = "#cccccc";
				//div.style.height = "960px";
				//div.style.overflow = "auto";

				//let first = div.firstChild;
				//div.insertBefore(header, first);

				document.querySelector('body').appendChild(div);
				let tds = div.querySelectorAll('td');
				for (var i = 0; i < tds.length; i++) {
					tds[i].style.padding = '4px';
				}

				printJS({
					printable: printDOMID,
					type: 'html',
					scanStyles: false
				});

				div.remove();
			}
		},
		created() {
			let ths = this;
			var d = new Date();
			d.setMonth(d.getMonth() - 1);
			d.setDate(1);
			var d1 = new Date(d);
			d1.setMonth(d1.getMonth() + 1);
			d1.setDate(0);
			ths.data.date = [d.toDateFormatString('yyyy-MM-dd'), d1.toDateFormatString('yyyy-MM-dd')];
			ths.baseJS.initPower(ths.power);
			ths.search();
		},
		mounted() {}
	}
</script>

<style scoped>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}
</style>
